module.exports = {"621121100":"平襄镇","621121101":"马营镇","621121102":"鸡川镇","621121103":"榜罗镇","621121104":"常家河镇","621121105":"义岗川镇","621121200":"陇阳乡","621121201":"陇山乡","621121202":"陇川乡","621121203":"新景乡","621121204":"碧玉乡","621121206":"襄南乡","621121207":"李家店乡","621121210":"什川乡","621121212":"第三铺乡","621121214":"华家岭乡","621121215":"寺子川乡","621121216":"北城铺乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/621121.json
// module id = 2735
// module chunks = 0